// Creator
export const creatorKey = "creator";

// TEXT COMPLIANCE
export const blockedPhrasesKey = "blockedPhrases";

// CONSULTATION
export const availabilitiesKey = ["availabilities"];

// MYM CLOUD
export const collectionsKey = "collections";
export const collectionKey = "collection";

// PLAYLIST
export const playlistsKey = "playlists";
export const playlistKey = "playlist";

// POST
export const postsKey = ["posts"];
export const postKey = ["post"];
export const postCalendarRestrictionsKey = ["post-calendar-restrictions"];
export const postCalendarDatesKey = ["post-calendar-dates"];

// PUSH
export const pushKey = "push";
export const pushCreatorAudienceKey = "push-creator-audience";
export const pushPricesKey = "push-prices";
export const pushDiscountDurationsKey = "push-discount-durations";
export const pushCreationKey = "create-push";
export const pushCalendarRestrictionsKey = "push-calendar-restrictions";
export const pushByIdCalendarRestrictionsKey =
  "push-by-id-calendar-restrictions";
export const pushCalendarDatesKey = "push-calendar-dates";
export const pushCreatePresignedUrlKey = "push-create-presigned-url";
export const pushUploadMediaKey = "push-upload-media";
export const pushUpdateUploadMediaKey = "push-update-upload-media";

// CHAT
export const chatsKey = ["chats"];
export const chatKey = ["chat"];
export const messagesKey = ["messages"];
export const voiceMessagesFeatureFlagKey = ["korben", "feature-flags"];

// MEDIAS
export const mediasKey = ["medias"];
